import { render, staticRenderFns } from "./RegisterParceiros.html?vue&type=template&id=459a13a2&external"
import script from "./RegisterParceiros.vue?vue&type=script&lang=js"
export * from "./RegisterParceiros.vue?vue&type=script&lang=js"
import style0 from "./RegisterParceiros.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports